import { render, staticRenderFns } from "./IsardCalendar.vue?vue&type=template&id=4af1cf7e&"
import script from "./IsardCalendar.vue?vue&type=script&lang=js&"
export * from "./IsardCalendar.vue?vue&type=script&lang=js&"
import style0 from "./IsardCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports